// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + ({"543":"gallery","792":"main"}[chunkId] || chunkId) + "." + {"543":"d7a8355aee0001adce92","792":"78096254259ff69bf0cd","867":"b13b783c32d9582436b5"}[chunkId] + ".css";
};